import React, { FC } from 'react'
import cn from 'clsx'
 
import { CompanyRole } from '@sdk/API';

interface RoleBadgeProps extends React.ComponentPropsWithoutRef<'div'> {
  role: string
}

const ROLE_CN = {
  [CompanyRole.EMPLOYEE]: "bg-yellow text-black",
  [CompanyRole.PROXY]: "bg-magenta",
  [CompanyRole.REPRESENTATIVE]: "bg-green",
  [CompanyRole.ADMIN]: "bg-red",
}
 
const RoleBadge: FC<RoleBadgeProps> = ({
  role,
  className,
  ...props
}) => {
  return (
    <span className={cn("text-sm px-1", ROLE_CN[role], className)} {...props}>
      {role}
    </span>
  )
}
 
export default RoleBadge